// src/i18n/index.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import uk from "./locales/ua/translation.json";
import en from "./locales/en/translation.json";

i18n
  // детектор мови (браузер, localStorage тощо)
  .use(LanguageDetector)
  // підключаємо до React
  .use(initReactI18next)
  .init({
    resources: {
      uk: {
        translation: uk,
      },
      en: {
        translation: en,
      },
    },
    fallbackLng: "uk",            // мова за замовчуванням
    supportedLngs: ["uk", "en"],  // які мови підтримуємо
    debug: false,                 // можна увімкнути true під час розробки

    interpolation: {
      escapeValue: false, // React сам екранує
    },
    detection: {
      // опційно: в які джерела дивиться детектор
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
